module.exports = __webpack_public_path__ + "img/icon-gj.c5e939bf.png";